module.exports = __webpack_public_path__ + "img/image_consulting.e2f7c1ca.svg";